// extracted by mini-css-extract-plugin
module.exports = {"table":"EcgsTable_table__V5shG","findings":"EcgsTable_findings__Pqxia","archivedEcg":"EcgsTable_archivedEcg__3hDs3","entityContactIcon":"EcgsTable_entityContactIcon__39uhk"};